interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <nav className="mt-10 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={[
            "h-9 w-9 rounded-md text-sm transition-colors cursor-pointer",
            page === current
              ? "bg-primary-500 font-semibold text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600",
          ].join(" ")}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(current + 1)}
        disabled={current === total}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}